/* RESPONSIBLE TEAM: team-inbox-experience */
import ApplicationAdapter from '../application';

export default class DomainObjectTypeAdapter extends ApplicationAdapter {
  pathForType() {
    return 'domain_object_types';
  }
}
